import(/* webpackMode: "eager" */ "/home/tambov/DEV/23ZULU/zulupool-frontend2/app/globals.css");
;
import(/* webpackMode: "eager" */ "/home/tambov/DEV/23ZULU/zulupool-frontend2/app/(site)/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tambov/DEV/23ZULU/zulupool-frontend2/components/antd-styles-workaround/AntdStyledComponentsRegistry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tambov/DEV/23ZULU/zulupool-frontend2/components/api-connection/ApiConnectionNotifier.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tambov/DEV/23ZULU/zulupool-frontend2/components/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tambov/DEV/23ZULU/zulupool-frontend2/components/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tambov/DEV/23ZULU/zulupool-frontend2/components/polyfills/RuntimeAssetGuard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tambov/DEV/23ZULU/zulupool-frontend2/components/polyfills/TouchEventPolyfill.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tambov/DEV/23ZULU/zulupool-frontend2/components/Sidebar/Sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tambov/DEV/23ZULU/zulupool-frontend2/components/site-message/SiteMessageNotifier.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tambov/DEV/23ZULU/zulupool-frontend2/components/storage/StorageVersionGuard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/tambov/DEV/23ZULU/zulupool-frontend2/components/ThemeSwitcher/AntdThemeSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppProvider"] */ "/home/tambov/DEV/23ZULU/zulupool-frontend2/context/AppContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleProvider"] */ "/home/tambov/DEV/23ZULU/zulupool-frontend2/context/LocaleContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/tambov/DEV/23ZULU/zulupool-frontend2/node_modules/@ant-design/v5-patch-for-react-19/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/home/tambov/DEV/23ZULU/zulupool-frontend2/node_modules/next-themes/dist/index.mjs");
